/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "522")




export interface API47916Req {
  
  /** 项目编号 */
  projectNo?: string;
  /** 项目计划编号 */
  planNo?: string;
  /** 任务标题,必填 */
  taskTitle?: string;
  /** 任务描述 */
  taskDesc?: string;
  /** 执行人用户id列表 ,String */
  taskExecutorIdList?: any[];
  /** 抄送人用户id列表 ,String */
  taskCcIdList?: any[];
  /** 任务完成标准(1:或签,2:会签，默认1)，详见com.ywwl.foundation.teamwork.client.enums.TaskCompleteTypeEnum */
  taskCompleteType?: number;
  /** 计划开始时间,yyyy-mm-ddhh:mm */
  startTime?: any;
  /** 计划完成时间,yyyy-mm-ddhh:mm */
  endTime?: any;
  /** 优先级(1:较低,2:普通,3:紧急,4:非常紧急),详见TaskPriorityEnum */
  taskPriority?: number;
  /** 能否处理已逾期的任务 */
  canExecOverdue?: boolean;
};



export type API47916Res = {};


// 47916 保存新增任务

export interface IUsePostAPI47916Return {
  /** 保存新增任务: 接口请求状态 */
  isAPI47916Loading: boolean;
  /** 保存新增任务: 接口请求返回数据 */
  dataAPI47916: API47916Res;
  /**  保存新增任务: 接口数据请求方法 */
  fetchAPI47916Data:  (inputs: API47916Req, config?: YWRequestConfig) => Promise<API47916Res>;
  /** 保存新增任务: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI47916 = ():IUsePostAPI47916Return => {
  let isMount = true;
  const [isAPI47916Loading, setIsAPI47916Loading] = useState(false);
  const [dataAPI47916, setDataAPI47916] = useState<API47916Res>({} as API47916Res);
  const requestUrl = `${basePath}/corp-admin/project/plan/task/save`;

  const fetchAPI47916Data = async (inputs: API47916Req, config?: YWRequestConfig): Promise<API47916Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API47916Req>) || {}) as API47916Req;
    
  
    if ( isMount ) {
      setIsAPI47916Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API47916Res>(`${basePath}/corp-admin/project/plan/task/save`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI47916(res || {} as API47916Res);
        setIsAPI47916Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI47916Loading(false);
      }
      return false as unknown as API47916Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI47916Loading,
    dataAPI47916,
    fetchAPI47916Data,
    requestUrl,
  }
}

